import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../shared.module';
import { SidebarModule } from '../sidebar/sidebar.module';
import { ButtonHelpComponent } from './button-help.component';

@NgModule({
  declarations: [ButtonHelpComponent],
  imports: [
    SharedModule,
    MatButtonModule,
    MatTooltipModule,
    SidebarModule
  ],
  exports: [ButtonHelpComponent],
})
export class ButtonHelpModule { }
